import { useState } from "react";
import { DEFAULT_PHYSICS, type PhysicsParams } from "../NeighborField";

export type PhysicsMode = "base" | "neighbor";

/** Owns the swarm physics mode (base morph vs neighbor sim) and its dials. */
export function usePhysics() {
  const [mode, setMode] = useState<PhysicsMode>("neighbor");
  const [params, setParams] = useState<PhysicsParams>(DEFAULT_PHYSICS);
  const setParam = (k: keyof PhysicsParams) => (v: number) => setParams((s) => ({ ...s, [k]: v }));
  return { mode, setMode, params, setParam };
}
